import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import type { Sheet } from '@yana/shared';
import { sheetsApi } from '@/api/sheets';
import { useAuthStore } from './auth';

/** Общий каталог книги. Данные и настройки открытых листов хранятся отдельно. */
export const useSheetCatalogStore = defineStore('sheetCatalog', () => {
  const auth = useAuthStore();
  const sheets = ref<Sheet[]>([]);
  const loaded = ref(false);
  const revision = ref(0);
  let generation = 0;
  let request = 0;
  let pending: Promise<void> | null = null;

  function loadList(force = false): Promise<void> {
    if (!force && loaded.value) return Promise.resolve();
    if (!force && pending) return pending;
    const session = generation;
    const current = ++request;
    const promise = sheetsApi.list().then(list => {
      if (session !== generation || current !== request) return;
      sheets.value = list;
      loaded.value = true;
      revision.value += 1;
    }).catch(() => {
      // Ошибка сети не удаляет уже открытые вкладки и их данные.
    }).finally(() => { if (pending === promise) pending = null; });
    pending = promise;
    return promise;
  }

  watch([() => auth.user?.id, () => auth.user?.role], () => {
    generation += 1;
    pending = null;
    sheets.value = [];
    loaded.value = false;
  }, { flush: 'sync' });

  return { sheets, loaded, revision, loadList };
});
